import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { Button, Summary } from '@sololearnorg/sol';
import { Container } from '../../../../../symphony';

import { ActionType, RequestType } from '../../../global-interface';
import { getNotFoundPages, SlLEContext } from '../../../global-constants';
import { SlActions } from '../../../services/ActionsService/sl-actions';
import { ActionButtonTypes } from '../../../../../shared/public/SlActionButton/SlActionButton';

import s from './LessonNotFound.scss';

export function LessonNotFound(): JSX.Element {
	useStyles(s);
	const onButtonClick = (): void => {
		const { actions$ } = Container.take(SlLEContext, SlActions);
		actions$.next({
			type: ActionType.OnLessonNotFoundClick,
			requestType: RequestType.Parallel,
		});
	};
	return (
		<div sl-test-data="cmpLELessonNotFound">
			<Summary
				actions={[
					<Button
						sl-test-data="btnLessonNotFound"
						type={ActionButtonTypes.primary}
						onClick={onButtonClick}
						key="btnLessonNotFound"
					>
						{getNotFoundPages().LESSON_NOT_FOUND.button.title}
					</Button>,
				]}
				className="le-not-found"
				description={getNotFoundPages().LESSON_NOT_FOUND.description}
				headline={getNotFoundPages().LESSON_NOT_FOUND.title}
			/>
		</div>
	);
}
